const isApp = !!window.navigator.userAgent.match('BNSAPP_VER')
const isAppLogin =
	!!window.navigator.userAgent.match('BNSAPP_VER') &&
	!!window.navigator.userAgent.match('BNS_LOGIN/1')

export { isApp, isAppLogin }
